import { render } from "./ExampleTable.vue?vue&type=template&id=58c7adf8"
import script from "./ExampleTable.vue?vue&type=script&lang=ts"
export * from "./ExampleTable.vue?vue&type=script&lang=ts"
script.render = render

export default script